import { api } from "~/utils/api"

type Utils = ReturnType<typeof api.useUtils>

/** Everything a package write can change. The line queries refresh on the run's NOTIFY. */
export function invalidatePackageReaders(utils: Utils) {
  return Promise.all([
    utils.allocation.getPackages.invalidate(),
    utils.allocation.getStores.invalidate(),
    utils.allocation.getStoreTimeline.invalidate(),
  ])
}

/** Everything a store settings save can change, transit time included. */
export function invalidateStoreReaders(utils: Utils) {
  return Promise.all([
    utils.allocation.getStoreSetup.invalidate(),
    utils.allocation.getStores.invalidate(),
    utils.allocation.getRules.invalidate(),
    utils.allocation.getAllocationStoreMap.invalidate(),
    utils.allocation.getStoreDetail.invalidate(),
    utils.allocation.getStoreReport.invalidate(),
    utils.allocation.getRuleImpactLines.invalidate(),
  ])
}
